<template>
	<div class="kun_loading22_container">
		<div class="loader">
			<span class="bar"></span>
			<span class="bar"></span>
			<span class="bar"></span>
		</div>
	</div>
</template>


<script>
	export default {
		name: "kun_loading22",
	}
</script>


<style scoped>
	.kun_loading22_container {
		display: flex;
		justify-content: center;
		align-items: center;

	}

	.loader {
		display: flex;
		align-items: center;
	}

	.bar {
		display: inline-block;
		width: 3px;
		height: 20px;
		background-color: rgb(47, 253, 0);
		border-radius: 10px;
		animation: scale-up4 1s linear infinite;
	}

	.bar:nth-child(2) {
		height: 35px;
		margin: 0 5px;
		animation-delay: .25s;
	}

	.bar:nth-child(3) {
		animation-delay: .5s;
	}

	@keyframes scale-up4 {
		20% {
			background-color: #1fc2bd;
			transform: scaleY(1.5);
		}

		40% {
			transform: scaleY(1);
		}
	}
</style>
